const infocontact = (state = [], action) => {
    switch (action.type) {
      case 'CONTACT_INFO':
          return {
              infocontact: action.post
          }
      default:
        return state
    }
  }
  
  export default infocontact